import React from 'react';
import './styles.scss';

const ProgressBar = ({completedCount, totalCount, currentLabel}) => {
	const displayedCompletedCount = totalCount
		? Math.min(completedCount, totalCount)
		: completedCount;
	const percentage = totalCount
		? Math.min((displayedCompletedCount / totalCount) * 100, 100)
		: 0;

	return (
		<div className="screening-progress">
			<div className="screening-progress__top">
				<span className="screening-progress__label">
					Deltest {displayedCompletedCount} av {totalCount}
					{currentLabel ? `: ${currentLabel}` : ''}
				</span>
				<span className="screening-progress__percent">
					{Math.round(percentage)}%
				</span>
			</div>

			<div className="screening-progress__bar">
				<div
					className="screening-progress__fill"
					style={{width: `${percentage}%`}}
				/>
			</div>
		</div>
	);
};

export default ProgressBar;
